import { render, staticRenderFns } from "./InlineLegendWidgetCell.vue?vue&type=template&id=334d95c5&scoped=true"
import script from "./InlineLegendWidgetCell.vue?vue&type=script&lang=js"
export * from "./InlineLegendWidgetCell.vue?vue&type=script&lang=js"
import style0 from "./InlineLegendWidgetCell.vue?vue&type=style&index=0&id=334d95c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d95c5",
  null
  
)

export default component.exports